import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useResourceUserDetailsContext } from '~/modules/resource-management/resourceUserDetails/ResourceUserDetailsContext';
import { RESOURCE_USER_DETAILS_ACTION } from '~/modules/resource-management/resourceUserDetails/hooks/resourceUserDetailsAction';
import useBulkRejectUserCertificateNudge from './useBulkRejectUserCertificateNudge';

export const useOnRejectCertificateNudges = ({ userUri }) => {
  const intl = useIntl();
  const { dispatch } = useResourceUserDetailsContext();

  const { bulkRejectUserCertificateNudge } = useBulkRejectUserCertificateNudge({
    userUri
  });

  const onRejectCertificateNudgesComplete = useCallback(
    ({ requestedCertificates, errorCount }) => {
      if (!requestedCertificates?.length) return;

      dispatch({
        type: RESOURCE_USER_DETAILS_ACTION.SET_SNACKBAR_MESSAGE,
        snackbarMessage: errorCount
          ? intl.formatMessage(
              {
                id:
                  'resourceCertificatesAndLicensesCard.suggestionRejectedError'
              },
              { count: requestedCertificates?.length }
            )
          : requestedCertificates?.length > 1
          ? intl.formatMessage({
              id: 'resourceCertificatesAndLicensesCard.allSuggestionsRejected'
            })
          : intl.formatMessage(
              { id: 'resourceCertificatesAndLicensesCard.suggestionRejected' },
              { certificate: requestedCertificates[0].name }
            )
      });
    },
    [intl, dispatch]
  );

  const onRejectCertificateNudges = useCallback(
    async certificates => {
      const nudgeIds = certificates.map(certificate => certificate.nudgeId);

      const {
        data: {
          bulkRejectUserCertificateNudge: bulkRejectUserCertificateNudgeData
        }
      } = await bulkRejectUserCertificateNudge(nudgeIds);

      const bulkRejectUserCertificateNudgeErrors =
        bulkRejectUserCertificateNudgeData?.errors || [];

      onRejectCertificateNudgesComplete({
        requestedCertificates: certificates,
        errorCount: bulkRejectUserCertificateNudgeErrors.length
      });
    },
    [bulkRejectUserCertificateNudge, onRejectCertificateNudgesComplete]
  );

  return {
    onRejectCertificateNudges
  };
};
